import { render } from "./config.vue?vue&type=template&id=59eddc9a&scoped=true&ts=true"
import script from "./config.vue?vue&type=script&lang=ts"
export * from "./config.vue?vue&type=script&lang=ts"

import "./config.vue?vue&type=style&index=0&id=59eddc9a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59eddc9a"]])

export default __exports__